import "./component-product.scss";
import { html, nothing, PropertyValues } from "lit";
import ComponentBase from "./component-base";
import ComponentQuantitySelector from "./component-quantity-selector";
import placeholderImage from "../assets/images/product_placeholder.png";
import { FormatPrice } from "../assets/js/libs/utils";
import ProductCustomizationModal from "./product-customization-modal";
import { property, state } from "lit/decorators.js";
import { ProductDto } from "../model/dtos";
import {
  selectConfigShowPrices,
  selectItemsFromCart,
} from "../webapps/shop/redux/actions";
import store from "../webapps/shop/redux/store";

class ComponentProduct extends ComponentBase {
  static get tagName() {
    return "component-product";
  }

  @property()
  product: ProductDto;
  @state()
  showPrice: boolean;
  @property()
  mode: "grid" | "list" = "grid";

  constructor() {
    super();
    this.popoverTimeout = null;
    this.classList.add("w-100");
    this.showingQtyDialog = false;
    this.actionCanceled = false;
    this.OnTouchMove = this.OnTouchMove.bind(this);
    this.OnMouseUp = this.OnMouseUp.bind(this);
    this.OnMouseDown = this.OnMouseDown.bind(this);
    this.showPrice = selectConfigShowPrices();
  }

  connectedCallback(): void {
    super.connectedCallback();
    store.subscribe(() => {
      this.showPrice = selectConfigShowPrices();
      this.requestUpdate();
    });
  }

  get count() {
    const items = selectItemsFromCart();
    let count = 0;
    items.forEach((item) => {
      if (item.id === this.product.id) count += item.quantity;
    });
    return count;
  }

  SetClass() {
    if (this.product.stock == 0) {
      this.classList.remove("low-stock");
      this.classList.add("out-of-stock");
    } else if (this.product.stock <= 10) {
      this.classList.remove("out-of-stock");
      this.classList.add("low-stock");
    } else {
      this.classList.remove("out-of-stock");
      this.classList.remove("low-stock");
    }
  }

  firstUpdated() {
    this.SetClass();
    const product = this.querySelector(".Product");
    product.addEventListener("touchmove", this.OnTouchMove);
    product.addEventListener("touchend", this.OnMouseUp);
    product.addEventListener("touchstart", this.OnMouseDown);
    if ("ontouchstart" in window == false) {
      product.addEventListener("mousedown", this.OnMouseDown);
      product.addEventListener("mouseup", this.OnMouseUp);
    }
  }

  updated(changedProperties: PropertyValues<this>) {
    // TODO: stock ora fa parte dell'oggetto product. Rivedere.
    // if (changedProperties.has("stock")) {
    //   this.SetClass();
    // }
  }

  OnMouseDown(e: TouchEvent) {
    if (e.touches) {
      this.clientX = e.touches[0].clientX;
      this.clientY = e.touches[0].clientY;
    }
    // e.preventDefault();
    this.popoverTimeout = setTimeout(async () => {
      this.showingQtyDialog = true;
      const quantity = await ComponentQuantitySelector.Show();
      this.showingQtyDialog = false;
      if (quantity > 0) this.AddProduct(quantity);
    }, 400);
  }

  OnMouseUp(e: TouchEvent) {
    if (e.changedTouches) {
      const clientX = e.changedTouches[0].clientX;
      const clientY = e.changedTouches[0].clientY;
      const deltaX = clientX - this.clientX;
      const deltaY = clientY - this.clientY;
      console.log(deltaX, deltaY);
      if (Math.abs(deltaY) > 100 && this.actionCanceled == false) {
        console.info("touchmove not detected");
        this.actionCanceled = true;
        clearTimeout(this.popoverTimeout);
      }
    }
    if (this.actionCanceled) {
      this.actionCanceled = false;
      return;
    }
    if (this.showingQtyDialog) return;

    clearTimeout(this.popoverTimeout);
    this.AddProduct(1);
  }

  OnTouchMove(e) {
    console.log("OnTouchMove");
    this.actionCanceled = true;
    clearTimeout(this.popoverTimeout);
  }

  async AddProduct(qty) {
    let customizations = undefined;
    if (this.product.customizations?.length > 0) {
      await new Promise((resolve) => {
        setTimeout(resolve, 50);
      });
      customizations = await ProductCustomizationModal.Show(
        this.product.customizations
      );
    }
    this.dispatchEvent(
      new CustomEvent("addProduct", {
        detail: { quantity: qty, customizations },
      })
    );
  }

  OnImageError(e) {
    const img = e.currentTarget;
    img.src = placeholderImage;
    img.style.objectFit = "contain"; // placeholder image does not fill well as "cover"
  }

  render() {
    return html`
      <div class="shadow-sm card user-select-none Product ${this.mode}">
        <img
          @error=${this.OnImageError}
          src="${this.product.thumbnail}"
          class="card-img-top"
        />
        <div class="card-body">
          <h5 class="card-title">${this.product.name}</h5>
          <!--p class="card-text">${this.product.description}</p-->
          ${this.showPrice
            ? html` <p class="card-text price">
                <span>
                  <i class="bi bi-bag"></i>
                  ${this.count}
                </span>
                <span
                  >${(this.product.customizations ? "da " : "") +
                  FormatPrice().format(this.product.price)}</span
                >
              </p>`
            : nothing}
          <!--<a href="#" class="btn btn-primary">Go somewhere</a>-->
          ${this.RenderStockStatus()}
        </div>
      </div>
    `;
  }

  RenderStockStatus() {
    return null;
    return html`<div class="stock-status"></div>`;
  }
}
ComponentProduct.Register();
export default ComponentProduct;
